"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetResponseT = exports.ResetResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const reset_status_js_1 = require("../../solarxr-protocol/rpc/reset-status.js");
const reset_type_js_1 = require("../../solarxr-protocol/rpc/reset-type.js");
class ResetResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsResetResponse(bb, obj) {
        return (obj || new ResetResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsResetResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ResetResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    resetType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : reset_type_js_1.ResetType.Yaw;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : reset_status_js_1.ResetStatus.STARTED;
    }
    static startResetResponse(builder) {
        builder.startObject(2);
    }
    static addResetType(builder, resetType) {
        builder.addFieldInt8(0, resetType, reset_type_js_1.ResetType.Yaw);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(1, status, reset_status_js_1.ResetStatus.STARTED);
    }
    static endResetResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createResetResponse(builder, resetType, status) {
        ResetResponse.startResetResponse(builder);
        ResetResponse.addResetType(builder, resetType);
        ResetResponse.addStatus(builder, status);
        return ResetResponse.endResetResponse(builder);
    }
    unpack() {
        return new ResetResponseT(this.resetType(), this.status());
    }
    unpackTo(_o) {
        _o.resetType = this.resetType();
        _o.status = this.status();
    }
}
exports.ResetResponse = ResetResponse;
class ResetResponseT {
    constructor(resetType = reset_type_js_1.ResetType.Yaw, status = reset_status_js_1.ResetStatus.STARTED) {
        this.resetType = resetType;
        this.status = status;
    }
    pack(builder) {
        return ResetResponse.createResetResponse(builder, this.resetType, this.status);
    }
}
exports.ResetResponseT = ResetResponseT;
